import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AmplifyAuthService } from '../services/auth/amplify-auth.service';
import { RumInitializerService } from '../services/rum/rum-initializer.service';

export const authGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
    const router = inject(Router);
    const amplifyAuthService = inject(AmplifyAuthService);
    const rumService = inject(RumInitializerService);

    if (amplifyAuthService.isAuthenticated) {
        return true;
    }

    try {
        await amplifyAuthService.checkAuthState();
        return amplifyAuthService.isAuthenticated
            ? true
            : router.parseUrl('/login');
    } catch (error) {
        rumService.recordError(error);
        return router.parseUrl('/login');
    }
};
